/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropminage2Inputs */

const en_dropminage2 = /** @type {(inputs: Dropminage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum age`)
};

const de_dropminage2 = /** @type {(inputs: Dropminage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestalter`)
};

/**
* | output |
* | --- |
* | "Minimum age" |
*
* @param {Dropminage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropminage2 = /** @type {((inputs?: Dropminage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropminage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropminage2(inputs)
	return de_dropminage2(inputs)
});
export { dropminage2 as "dropMinAge" }